import React from 'react';
import { WsDataBreakdown } from '../../components/DataBreakdown/DataBreakdown';

const WsDataBreakdownPage = (props: any) => {
  return (
    <div>
      <WsDataBreakdown />
    </div>
  );
};

export { WsDataBreakdownPage };
